/**
 * Parses a cancellation policy code (e.g. '3day', '1day', '0day') and returns a
 * number of days for display. Returns undefined if the code can't be parsed.
 */
export const getParseCancellationDays = (policy: string): number | undefined => {
  const match = policy.match(/^(\d+)day$/);
  if (!match) return undefined;
  return parseInt(match[1], 10);
};
